import { X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion"
import { useEffect } from "react";

export default function FullscreenModal({onCloseModal, children, isOpen}){

    const animationDuration = 0.15;


    useEffect(() => {
        const handleEscapeKey = (e) => {
            if(e.key === 'Escape'){
                onCloseModal();
            }
        } 

        document.addEventListener('keydown', handleEscapeKey);

        return() => {
            document.removeEventListener('keydown', handleEscapeKey);
        };

    }, [onCloseModal]);

    return(
        <>
            <AnimatePresence>
            {
                isOpen && (
                    <motion.div
                        className="
                            w-full
                            h-full
                            bg-white

                            fixed
                            top-1/2
                            left-1/2
                            -translate-x-1/2
                            -translate-y-1/2
                            z-50
                        "
                        initial={{
                            opacity: 0
                        }}
                        animate={{
                            opacity: "100%",
                        }}
                        exit={{
                            opacity: 0
                        }}
                        transition={{
                            duration: animationDuration,
                            ease: "easeInOut",
                        }}
                    >
                        {
                            children
                        }
                        <div
                            className="
                                absolute
                                top-10
                                right-10
                                cursor-pointer
                                shadow-lg
                                shadow-white
                            "
                            onClick={onCloseModal}
                        >
                            <X />
                        </div>
                    </motion.div>
                )
            }

            </AnimatePresence>
        </>
    );

}